import { BehaviorSubject } from 'rxjs'
import { map, distinctUntilChanged, takeUntil, skip } from 'rxjs/operators'
import { isFunction, isEqual } from '../libraries/lodash'
import { getHistoryState, updateHistoryState } from '../core/history'

const getPageState = function () {
  return getHistoryState().pageState || {}
}

export const PageIdSubject = (new BehaviorSubject())
const PageId = PageIdSubject.pipe(distinctUntilChanged())
export const CurrentState = new BehaviorSubject(getPageState())
export const CurrentView = new BehaviorSubject(getHistoryState().pageView || 'main')

export const observePageState = function (id) {
  if (id) {
    return CurrentState.pipe(
      map(x => x[id]),
      map(s => s || 0),
      distinctUntilChanged(isEqual),
      takeUntil(PageId.pipe(skip(1)))
    )
  }

  return CurrentState.pipe(
    distinctUntilChanged(isEqual),
    takeUntil(PageId.pipe(skip(1)))
  )
}

export const updatePageState = function (newState) {
  const finalState = isFunction(newState) ? newState(CurrentState.value) : newState
  CurrentState.next({ ...CurrentState.value, ...finalState })
}

export const replacePageState = function (newState) {
  CurrentState.next(newState)
}

CurrentState.forEach(pageState => {
  updateHistoryState({ pageState })
})

export const flushPageState = function (pageId) {
  const previousState = CurrentState.value
  const previousPageId = PageIdSubject.getValue()
  if (previousPageId !== pageId) {
    PageId.next(pageId)
    CurrentState.next(getPageState())
  } else {
    updateHistoryState({ pageState: previousState, pageId })
  }
  return previousState
}

export const updatePageView = function (pageView, pageId) {
  updateHistoryState({ pageView, pageId })
  CurrentView.next(pageView)
}
